export const truncateContent = (_content: string) => {
  const div = document.createElement('div');
  div.innerHTML = _content;
  const content = div.textContent || div.innerText || '';
  div.remove();
  return content;
};
